import React from "react";

const Radio = ({
  name,
  value,
  checked,
  onChange,
  label,
  disabled = false,
  className = "",
  colorIndicator = null, // Optional color indicator (hex color string)
  showRadio = true, // Whether to show the radio button circle
}) => {
  return (
    <label
      className={`flex items-center gap-3 cursor-pointer ${disabled ? "opacity-50 cursor-not-allowed" : ""} ${className}`}
    >
      {/* Color Indicator (optional) */}
      {colorIndicator && (
        <span
          className="w-4 h-4 flex-shrink-0"
          style={{ borderRadius: "10px", backgroundColor: colorIndicator }}
        />
      )}

      {/* Radio Circle */}
      {showRadio && (
        <span
          className={`
            w-4 h-4 border
            flex items-center justify-center
            transition flex-shrink-0
            ${checked ? "border-brand-primary" : "border-border-primary"}
          `}
          style={{
            borderRadius: "10px",
          }}
        >
          {checked && <span className="w-2 h-2 rounded-full bg-brand-primary" />}
        </span>
      )}

      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
        disabled={disabled}
        className="hidden"
      />

      <span className="text-sm text-text-primary">{label}</span>
    </label>
  );
};

export default Radio;
